module.exports = __webpack_public_path__ + "img/2_70.d4caa6a9.png";